import Box from "ds/components/Box";
import PageInfoHeaderTitle from "ds/components/PageInfoHeader/Title";
import TooltipInfo from "ds/components/TooltipInfo";

type ModuleVersionPageIntoTitleProps = {
  title: string;
  tooltip: string;
};

const ModuleVersionPageIntoTitle = ({ title, tooltip }: ModuleVersionPageIntoTitleProps) => {
  return (
    <Box align="center" gap="medium">
      <PageInfoHeaderTitle title={title} />
      <TooltipInfo>{tooltip}</TooltipInfo>
    </Box>
  );
};

export default ModuleVersionPageIntoTitle;
